import React from 'react';
import ErrorStageUI from './ErrorStage.ui';

const ErrorStage = ({ error = '', onClose, onRetry }) => {
  return (
    <div className="error-stage-wrapper">
      <ErrorStageUI error={error} onClose={onClose} onRetry={onRetry} />
    </div>
  );
};

export default ErrorStage;
